export type NativeMonitoringStatus = {
  available?: boolean;
  usageAccessGranted?: boolean;
  serviceRunning?: boolean;
  shouldMonitor?: boolean;
};

type MonitoringChannel = { postMessage: (message: string) => void };

declare global {
  interface Window { NosivoMonitoring?: MonitoringChannel }
}

export function monitoringBridgeAvailable() {
  return typeof window !== 'undefined' && typeof window.NosivoMonitoring?.postMessage === 'function';
}

export function requestMonitoringRefresh() {
  window.NosivoMonitoring?.postMessage(JSON.stringify({ action: 'refresh' }));
}

export function clearAttendanceReminder() {
  window.NosivoMonitoring?.postMessage(JSON.stringify({ action: 'attendance_checked_out' }));
}

export function openUsageAccessSettings() {
  window.NosivoMonitoring?.postMessage(JSON.stringify({ action: 'open_usage_access' }));
}

export function requestMonitoringNotifications() {
  window.NosivoMonitoring?.postMessage(JSON.stringify({ action: 'request_notifications' }));
}

export function requestNativeMonitoringStatus() {
  window.NosivoMonitoring?.postMessage(JSON.stringify({ action: 'status' }));
}

export function listenForMonitoringStatus(listener: (status: NativeMonitoringStatus) => void) {
  const handler = (event: Event) => listener((event as CustomEvent<NativeMonitoringStatus>).detail || {});
  window.addEventListener('nosivo:device-monitoring-status', handler);
  return () => window.removeEventListener('nosivo:device-monitoring-status', handler);
}
